import { render, staticRenderFns } from "./SettingButtons.vue?vue&type=template&id=aa8f0c10&scoped=true&"
import script from "./SettingButtons.vue?vue&type=script&lang=js&"
export * from "./SettingButtons.vue?vue&type=script&lang=js&"
import style0 from "./SettingButtons.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SettingButtons.vue?vue&type=style&index=1&id=aa8f0c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8f0c10",
  null
  
)

export default component.exports